<template>
  <div class="relative">
    <button
      type="button"
      @click="toggleAccordion"
      :class="[
        error
          ? 'text-red-500 hover:text-red-700'
          : warning
            ? 'text-orange-500 hover:text-orange-600'
            : 'hover:text-theme-700',
      ]"
      class="relative w-full h-10 pr-10 text-left bg-white rounded-md cursor-pointer sm:text-sm sm:leading-6 group py-1.5 pl-3 ring-1 ring-inset ring-gray-300 focus:outline-none text-gray-900">
      <span class="block truncate">{{ name }} </span>
      <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <IconChevronUpDown
          class="w-5 h-5 text-gray-400 transition-colors duration-200 ease-in-out group-hover:text-theme-700" />
      </span>
    </button>
    <Transition
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div v-show="isOpen" class="h-full mt-1">
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import IconChevronUpDown from '@/assets/icons/IconChevronUpDown.vue';

defineProps<{
  name: string;
  error?: boolean;
  warning?: boolean;
}>();

const isOpen = ref(false);

function toggleAccordion() {
  isOpen.value = !isOpen.value;
}
</script>
